// Runtime Environment Configuration
// Get configuration from window.__ENV (set at runtime) or fallback to process.env (build time)
const getEnvVar = (key, fallback = null) => {
    // Try runtime config first, then build-time config, then fallback
    return (window.__ENV && window.__ENV[key]) || process.env[key] || fallback;
};

const baseUrl = getEnvVar("REACT_APP_BASE_URL");
const originUrl = getEnvVar("REACT_APP_ORIGIN_URL");
const reportUrl = getEnvVar("REACT_APP_REPORT_URL");
const fastApiUrl = getEnvVar("REACT_APP_FAST_API_URL");
const filterAiApiUrl = getEnvVar("REACT_APP_FILTER_AI_API_URL");
const appMode = getEnvVar("REACT_APP_MODE");
const s3HostUrl = getEnvVar("REACT_APP_S3_HOST_URL");

// Validation with helpful error messages
if (!baseUrl) {
    console.error("❌ REACT_APP_BASE_URL is not provided in runtime or build configuration");
    throw new Error("API Url is not provided.");
} else if (!originUrl) {
    console.error("❌ REACT_APP_ORIGIN_URL is not provided in runtime or build configuration");
    throw new Error("Origin Url is not provided.");
} else if (!reportUrl) {
    console.error("❌ REACT_APP_REPORT_URL is not provided in runtime or build configuration");
    throw new Error("Report url is not provided");
} else if (!fastApiUrl) {
    console.log("⚠️ Fast api url is not provided, using fallback");
    // throw new Error("Fast api url is not provided");
}

// Log configuration source for debugging
if (window.__ENV) {
    console.log("🔧 Using runtime environment configuration");
} else {
    console.log("🔧 Using build-time environment configuration (fallback)");
}

export const MAIN_ROUTE = `${baseUrl}/`;
export const API_ROUTE = `${baseUrl}`;
export const ORIGIN_URL = originUrl;
export const REPORT_URL = reportUrl;
export const FAST_API_URL = fastApiUrl || "https://prod-pybackend.fcatracker.com";
export const FILTER_AI_API_URL = filterAiApiUrl || "https://fcatracker.com";
export const APP_MODE = appMode || "tracker";
export const S3_HOST = s3HostUrl || "https://fca-tracker.s3.us-east-2.amazonaws.com";
export const APM_SERVER_URL = getEnvVar("APM_SERVER_URL");
export const APM_ENVIRONMENT = getEnvVar("APM_ENVIRONMENT");
export const RECAPTCHA_SITE_KEY = getEnvVar("REACT_APP_RECAPTCHA_SITE_KEY");
export const RECAPTCHA_V2_SITE_KEY = getEnvVar("REACT_APP_RECAPTCHA_V2_SITE_KEY");

// Harness FME (Split.io) feature flags — MIGRATION PREP plumbing.
// The per-environment Split BROWSER (client-side) SDK key is injected at runtime
// by the Harness Frontend deployment values per env. Defaults to ""
// so a missing key keeps every flag fail-safe OFF (legacy backend). Never commit
// real key values here.
export const FME_SDK_KEY = (window.__ENV && window.__ENV.REACT_APP_FME_SDK_KEY) || process.env.REACT_APP_FME_SDK_KEY || "";
// Both the SDK key and this name are per-environment. The key alone selects which
// FME environment's definitions are evaluated; this name is only reported as the
// `env` evaluation attribute. Defaulting it to a concrete environment therefore
// mislabels any deployment that forgets to set it, so it defaults to "".
export const FME_ENV = (window.__ENV && window.__ENV.REACT_APP_FME_ENV) || process.env.REACT_APP_FME_ENV || "";

// Presence heartbeat interval, in seconds (FCA-6979). Runtime-configurable so
// the interval can be widened without a rebuild if Cognito comes under
// pressure — every heartbeat costs one Cognito `GetUser` call. The value is
// clamped to a safe range in `presenceScheduler.resolveIntervalMs`.
export const PRESENCE_HEARTBEAT_SECONDS = getEnvVar("REACT_APP_PRESENCE_HEARTBEAT_SECONDS", "60");
